var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGifting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 9.17667V12.51C3.33331 15.2598 3.33331 16.6347 4.18759 17.4891C5.04185 18.3433 6.41679 18.3433 9.16665 18.3433H10.8333C13.5831 18.3433 14.9581 18.3433 15.8124 17.4891C16.6666 16.6347 16.6666 15.2598 16.6666 12.51V9.17667",
    stroke: "#303030",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.50999C2.5 6.88691 2.5 6.57537 2.66747 6.34332C2.77717 6.19131 2.93497 6.06506 3.125 5.9773C3.41507 5.84332 3.80448 5.84332 4.58333 5.84332H15.4167C16.1955 5.84332 16.5849 5.84332 16.875 5.9773C17.065 6.06506 17.2228 6.19131 17.3325 6.34332C17.5 6.57537 17.5 6.88691 17.5 7.50999C17.5 8.13306 17.5 8.44457 17.3325 8.67666C17.2228 8.82866 17.065 8.95491 16.875 9.04266C16.5849 9.17666 16.1955 9.17666 15.4167 9.17666H4.58333C3.80448 9.17666 3.41507 9.17666 3.125 9.04266C2.93497 8.95491 2.77717 8.82866 2.66747 8.67666C2.5 8.44457 2.5 8.13306 2.5 7.50999Z",
    stroke: "#303030",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3.16476C5 2.34291 5.66624 1.67667 6.48809 1.67667H6.78572C8.56092 1.67667 10 3.11575 10 4.89095V5.84333H7.67857C6.19923 5.84333 5 4.64409 5 3.16476Z",
    stroke: "#303030",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3.16476C15 2.34291 14.3338 1.67667 13.5119 1.67667H13.2142C11.4391 1.67667 10 3.11575 10 4.89095V5.84333H12.3214C13.8007 5.84333 15 4.64409 15 3.16476Z",
    stroke: "#303030",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.17667V18.3433",
    stroke: "#303030",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.00999451)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifting);
export default __webpack_public_path__ + "static/media/gifting.74b57f2a1ab5436b53706257d606cd4d.svg";
export { ForwardRef as ReactComponent };